import { EncodeObject, GeneratedType } from '@cosmjs/proto-signing';
import { MsgLockTokens, MsgBeginUnlocking, MsgBeginUnlockingAll } from './ts-client/tx';

export const lockupTypes: ReadonlyArray<[ string, GeneratedType ]> = [
  [ '/dymensionxyz.dymension.lockup.MsgLockTokens', MsgLockTokens ],
  [ '/dymensionxyz.dymension.lockup.MsgBeginUnlocking', MsgBeginUnlocking ],
  [ '/dymensionxyz.dymension.lockup.MsgBeginUnlockingAll', MsgBeginUnlockingAll ],
];

export interface MsgLockTokensEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.lockup.MsgLockTokens';
  readonly value: Partial<MsgLockTokens>;
}

export interface MsgBeginUnlockingEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.lockup.MsgBeginUnlocking';
  readonly value: Partial<MsgBeginUnlocking>;
}

export interface MsgBeginUnlockingAllEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.lockup.MsgBeginUnlockingAll';
  readonly value: Partial<MsgBeginUnlockingAll>;
}

export function isMsgLockTokensEncodeObject(object: EncodeObject): object is MsgLockTokensEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.lockup.MsgLockTokens';
}

export function isMsgBeginUnlockingEncodeObject(object: EncodeObject): object is MsgBeginUnlockingEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.lockup.MsgBeginUnlocking';
}

export function isMsgBeginUnlockingAllEncodeObject(object: EncodeObject): object is MsgBeginUnlockingAllEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.lockup.MsgBeginUnlockingAll';
}
